import React, { useEffect, useState, useMemo, memo } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Table from "../shared/table/Table";
import { FiEye, FiEdit3, FiTrash2, FiPlus, FiSave } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import usePermission from "../../hooks/usePermission";



const BASE_URL = process.env.REACT_APP_API_BASE_URL;


// Durum Switch Bileşeni
const StatusSwitch = memo(({ redirectId, currentStatus, fetchRedirects }) => {
  const [isChecked, setIsChecked] = useState(currentStatus === "active");

  const toggleStatus = async () => {
    const newStatus = isChecked ? "inactive" : "active";
    // Switch'i anında güncelle
    setIsChecked(!isChecked);

    try {
      await axios.put(`${BASE_URL}/api/redirects/update-status/${redirectId}`, {
        status: newStatus,
      });
      // Tabloyu yeniden çek
      fetchRedirects();
    } catch (error) {
      console.error("❌ Durum güncellenemedi:", error);
      // Hata varsa Switch'i geri al
      setIsChecked(isChecked);
      toast.error("Durum güncellenemedi!");
    }
  };

  return (
    <div className="form-check form-switch text-end d-flex align-items-end justify-content-end">
      <input
        className="form-check-input custom-checkbox"
        type="checkbox"
        role="switch"
        checked={isChecked}
        onChange={toggleStatus}
        style={{
          cursor: "pointer",
          width: "45px",
          height: "22px",
          transition: "0.3s ease-in-out",
        }}
      />
      <span
        className={`badge ms-2 ${isChecked ? "badge-success" : "badge-danger"}`}
        style={{
          padding: "6px 12px",
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: "bold",
          transition: "0.3s ease-in-out",
        }}
      >
      </span>
    </div>
  );
});

// Ana Bileşen
const RedirectTable = () => {
  const [redirects, setRedirects] = useState([]);
  const [newRows, setNewRows] = useState([
    { url: "", redirect_url: "", heats: 0, status: "active" },
  ]);
  const { canView, canEdit, canDelete, canCreate } = usePermission("static_url_redirect");


  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue = "") => translations[key] || defaultValue;

  const isTranslationsReady = Object.keys(translations).length > 0;

  // Veri çek
  const fetchRedirects = async () => {
    try {
      console.log("API'ye istek atılıyor..."); 
      const response = await axios.get(`${BASE_URL}/api/redirects`);
      console.log("API Yanıtı:", response.data); 
  
      setRedirects(response.data);
    } catch (error) {
      console.error("Yönlendirme verileri alınamadı:", error);
      toast.error("Yönlendirme verileri alınamadı!");
    }
  };
  useEffect(() => {
    fetchRedirects();
  }, []); 
  

  // Tablo Kolonları
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: getText("TABLE_ID_LABEL"),
        meta: { headerClassName: "text-start", className: "text-start" },
        size: 60,
      },
      {
        accessorKey: "url",
        header: getText("TABLE_URL_LABEL"),
        meta: { headerClassName: "text-start value-column", className: "text-start value-column" },
        size: 250,
        cell: (info) => {
          const val = info.getValue();
          return (
            <a href={val} target="_blank" rel="noopener noreferrer" style={{ fontWeight: "normal" }}>
              {val}
            </a>
          );
        },
      },
      {
        accessorKey: "redirect_url",
        header: getText("TABLE_REDIRECT_LABEL"),
        meta: { headerClassName: "text-start value-column", className: "text-start value-column" },
        size: 250,
        cell: (info) => {
          const val = info.getValue();
          return (
            <a href={val} target="_blank" rel="noopener noreferrer" style={{ fontWeight: "normal" }}>
              {val}
            </a>
          );
        },
      },
      {
        accessorKey: "hit",
        header: getText("TABLE_HIT_LABEL"),
        meta: { headerClassName: "text-end status-column", className: "text-end status-column" },
        size: 80,
        cell: (info) => {
          const val = info.getValue();
          return <div style={{ textAlign: "end" }}>{val}</div>;
        },
      },
      {
        accessorKey: "createdAt",
        header: () => <div style={{ textAlign: "end" }}>{getText("TABLE_DATE_LABEL")}</div>,
        meta: { headerClassName: "text-end", className: "text-end" },
        size: 150,
        cell: (info) => {
          const rawDate = info.getValue();
      
          const formattedDate = new Date(rawDate).toLocaleDateString('en-GB');
          return <div style={{ textAlign: "end" }}>{formattedDate}</div>;
        },
      },
      {
        accessorKey: "status",
        header: () => <div style={{ textAlign: "end" }}>{getText("TABLE_STATUS_LABEL")}</div>,
        meta: { headerClassName: "text-end", className: "text-end" },
        size: 130,
        cell: (info) => {
          const rowData = info.row.original;
          return (
            <div style={{ textAlign: "end" }}>
              {/* Status Switch */}
              <StatusSwitch
                redirectId={rowData.id}
                currentStatus={rowData.status}
                fetchRedirects={fetchRedirects}
              />
            </div>
          );
        },
      },
      {
        accessorKey: "actions",
        header: () => <div style={{ textAlign: "right", }}>{getText("TABLE_ACTIONS_LABEL")}</div>,
        enableSorting: false,
        meta: { headerClassName: "text-end", className: "text-end" },
        size: 180,
        cell: (info) => {
          const rowData = info.row.original;
          const rid = rowData.id;
          return (
            <div
              className="hstack gap-2 justify-content-end"
             
            >
             
              {/* Düzenle */}
              {canEdit && (
                  <Link
                    to={`/redirect/edit/${rid}`}
                    className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
                    title="Düzenle"
                  >
                    <FiEdit3 />
                  </Link>
                )}
                {canDelete && (
                  <button
                    className="avatar-text avatar-md text-danger bg-soft-danger border-soft-danger"
                    onClick={() => deleteRedirect(rid)}
                    title="Sil"
                  >
                    <FiTrash2 />
                  </button>
                )}

            </div>
          );
        },
      },
    ],
    [translations]);

    if (!isTranslationsReady) return null;

  // Crud Fonksiyonları
  const deleteRedirect = (id) => {
    confirmAlert({
      title: getText("DELETE_CONFIRM_TITLE"),
      message: getText("DELETE_CONFIRM_MSG"),
      buttons: [
        {
          label: getText("YES_DELETE"),
          onClick: async () => {
            try {
              await axios.delete(`${BASE_URL}/api/redirects/${id}`);
              toast.success(getText("REDIRECT_DELETED"));
              fetchRedirects();
            } catch (error) {
              console.error("❌ Yönlendirme silinemedi:", error);
              toast.error(getText("ERROR_REDIRECT_DELETE"));
            }
          },
        },
        {
          label: getText("CANCEL"),
          onClick: () =>
            toast.info(getText("DELETE_CANCELLED")),
        },
      ],
    });
  };
  

  // Yeni ekleme formu
  const addNewRow = () => {
    setNewRows([
      ...newRows,
      { url: "", redirect_url: "", heats: 0, status: "active" },
    ]);
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...newRows];
    updatedRows[index][field] = value;
    setNewRows(updatedRows);
  };

  const saveRedirects = async () => {
    // Boşluk kontrolü
    const validRows = newRows.filter(
      (row) => row.url.trim() && row.redirect_url.trim()
    );
    if (!validRows.length) {
      toast.warn(getText("WARNING_ADD_VALID_ROW"));
      return;
    }

    try {
      for (const row of validRows) {
   
        await axios.post(`${BASE_URL}/api/redirects`, row);
      }
      toast.success(getText("REDIRECT_SAVED"));
      setNewRows([{ url: "", redirect_url: "", heats: 0, status: "active" }]);
      fetchRedirects();
    } catch (error) {
      console.error("❌ Yönlendirme kaydedilemedi:", error);
      toast.error("Yönlendirme kaydedilemedi!");
    }
  };

  return (
    <div className="container mt-1">
      <ToastContainer />

     
        
        <Table data={redirects} columns={columns} />
      

      {/* YENİ EKLEME KARTI */}
      {canCreate && (
      <div className="card card-body general-info">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h5 className="fw-bold text-primary mb-0">{getText("LABEL_NEW_REDIRECT")}</h5>
        </div>

        {newRows.map((row, index) => (
          <div key={index} className="border rounded p-3 mb-3">
            <div className="row g-3">
              {/* URL */}
              <div className="col-md-4">
                <label className="form-label fw-bold">{getText("TABLE_URL_LABEL")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={getText("PLACEHOLDER_URL")}
                  value={row.url}
                  onChange={(e) =>
                    handleInputChange(index, "url", e.target.value)
                  }
                />
              </div>

              {/* Redirect URL */}
              <div className="col-md-4">
                <label className="form-label fw-bold">{getText("LABEL_REDIRECT_URL")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={getText("PLACEHOLDER_REDIRECT_URL")}
                  value={row.redirect_url}
                  onChange={(e) =>
                    handleInputChange(index, "redirect_url", e.target.value)
                  }
                />
              </div>

             
            </div>
          </div>
        ))}

        <div className="d-flex justify-content-end mb-3">
          <button className="btn btn-outline-primary" onClick={addNewRow}>
            <FiPlus /> {getText("ADD_NEW_ROW")}
          </button>
        </div>

        <div className="d-flex justify-content-center">
          <button className="btn btn-primary" onClick={saveRedirects}>
            <FiSave /> {getText("SAVE_BTN")}
          </button>
        </div>
      </div>
      )}
    </div>
  );
};

export default RedirectTable;
